<template>
    <PopoverRight ref="popoverMenu" width="550px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">编辑角色</h1>
            <el-form class="form-container" :model="roleInfo" :rules="roleRules" ref="userInfoForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">上级角色</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="name">
                            <el-input placeholder="请输入角色名称"  v-model="roleInfo.upName" disabled="disabled">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">角色名称</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="name">
                            <el-input placeholder="请输入角色名称"  v-model="roleInfo.name">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">角色描述</span>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="description">
                            <el-input placeholder="请输入描述"  v-model="roleInfo.description">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">是否启用</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="status">
                            <el-switch active-color="#13ce66" v-model="roleInfo.status" active-value='0' inactive-value='1'></el-switch>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-button">
                    <el-button type="primary" @click="submitForm('userInfoForm')">确 认</el-button>
                    <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>

<script>
import PopoverRight from '@/components/popoverRight/index'
import { modifyRole } from '@/service/user'
import {validateChat} from '@/utils/validate'
import { getRoleDetail } from '@/service/user'
export default {
    name: "edit",
    components: {
        PopoverRight
    },
    props: {
        callback: Function
    },
    data () {
        return {
            roleInfo: {
                id : 0,
                name: '',
                description : '',
                status : '0',
                upName: ''
            },
            roleRules: {
                name: [
                    { required: true, message: '请填写名称', trigger: 'blur' },
                    {validator:validateChat,type:4, trigger: 'blur',result:'角色名'},
                    { min: 2, max: 25, message: '长度在 2 到 25 个字符', trigger: 'blur' }
                ],
                description: [
                    { min: 6, max: 300, message: '长度在 6 到 300 个字符', trigger: 'blur' }
                ],
            },
        }
    },
    methods : {
        open (data) {
            this.roleInfo = Object.assign({}, this.roleInfo, data)
            if (this.roleInfo.up_role_id !== undefined && this.roleInfo.up_role_id !== '') {
                this.getUpRoleName(this.roleInfo.up_role_id)
            }
            this.$refs.popoverMenu && this.$refs.popoverMenu.open()
        },
        /** 关闭右侧悬浮层 */
        hide () {
            this.resetForm();
            this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
            this.$refs.userInfoForm && this.$refs.userInfoForm.clearValidate()
        },
        resetForm () {
            this.roleInfo = {
                id : 0,
                name: '',
                description : '',
                status : '0',
            }
        },
        submitForm (formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    let query = {
                        name:this.roleInfo.name,
                        description:this.roleInfo.description,
                        status:this.roleInfo.status,
                    }
                    modifyRole(this.roleInfo.id, query).then((data) => {
                        this.$message({
                            message: '修改成功',
                            type: 'success',
                            duration: 3 * 1000
                        })
                        this.resetForm()
                        this.hide()
                        this.callback && this.callback()
                    }).catch(err => {
                        const message = err.context ? err.context[0] : err.message
                        this.$message({
                            message: message || '修改失败',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    })

                } else {
                    return false
                }
            })
        },
        /** 根据角色id请求 */
        async getUpRoleName (id) {
            try {
                const res = await getRoleDetail(id)
                this.$set(this.roleInfo, 'upName', res.name)
            } catch (error) {
                this.$message({
                    type: 'error',
                    message: error.message
                })
            }
        }
    },
}
</script>

<style scoped>

</style>
